import { Component } from 'react';

import { Box, Button, TextField } from '@mui/material';
import _, { flowRight as compose } from 'lodash';
import { inject, observer } from 'mobx-react';
import { withRouter } from 'providers';

import styles from './styles';

class ShipmentDropoffDispatchForm extends Component {
  save = (e) => {
    const { shipment, closeForm, store } = this.props;
    const { shipmentStore } = store;
    shipmentStore.updateDropoffLocationInfo(shipment, () => {
      closeForm();
    });
  };

  componentDidMount() {
    const { store, shipment } = this.props;
    const { shipmentDropoffForm } = store.shipmentStore;
    // initial field first load
    shipmentDropoffForm.setField('dropoff_access_code', _.get(shipment, 'dropoff_access_code', ''));
    shipmentDropoffForm.setField('dropoff_additional_instruction', _.get(shipment, 'dropoff_additional_instruction', ''));
  }

  render() {
    const { store } = this.props;
    const { shipmentDropoffForm } = store.shipmentStore;

    return (
      <div style={styles.Container}>
        <div style={styles.HeaderTitle}>{`Override`}</div>
        <Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1, ...styles.GroupPanel }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                <Box sx={{ flex: 1 }}>
                  <div style={styles.GroupTitle}>{`Dropoff Access Code`}</div>
                  <div style={styles.Field}>
                    <TextField
                      value={shipmentDropoffForm.getField('dropoff_access_code', '')}
                      onChange={shipmentDropoffForm.handlerInput}
                      placeholder={`e.g: #1234`}
                      name={`dropoff_access_code`}
                      fullWidth
                      size="small"
                    />
                  </div>
                  <div style={styles.GroupTitle}>{`Dropoff Additional Instruction`}</div>
                  <div style={styles.Field}>
                    <TextField
                      value={shipmentDropoffForm.getField('dropoff_additional_instruction', '')}
                      onChange={shipmentDropoffForm.handlerInput}
                      placeholder={`e.g: Baby inside, do not ring the bell`}
                      name={`dropoff_additional_instruction`}
                      fullWidth
                      size="small"
                    />
                  </div>
                </Box>
              </Box>
            </Box>
          </Box>
          <Box sx={{ display: 'flex' }}>
            <Box sx={{ flex: 1 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 1 }}>
                <Button variant="outlined" size='small' disableElevation color="primary" onClick={this.props.closeForm}>
                  Cancel
                </Button>
                <Button variant="contained" size='small' disableElevation color="primary" onClick={this.save}>
                  Save
                </Button>
              </Box>
            </Box>
          </Box>
        </Box>
      </div>
    );
  }
}
export default compose(withRouter, inject('store'), observer)(ShipmentDropoffDispatchForm);
